import create from "zustand";
import { devtools } from "zustand/middleware"

import { BranchStrength, BranchPolSumry } from '../api/branch.api'

const Branch = (set, get) => ({
	BranchStrength: null,
    BranchPolSumry: null,
    BranchCode: null,
	getBranchStrength: async (BranchCode) => {
		//set({ BranchStrength: "loading" })
		await BranchStrength(BranchCode).then((r) => {
			if(r.data.response_code === '01'){
				set({ BranchStrength: r.data.responseUtility })
			}else{
				set({ BranchStrength: null })
			}
		})
	},
    getBranchPolSumry: async (BranchCode) => {
		//set({ BranchPolSumry: "loading" })
		await BranchPolSumry(BranchCode).then((r) => {
			if(r.data.response_code === '01'){
				set({ BranchPolSumry: r.data.responseUtility })
			}else{
				set({ BranchPolSumry: null })
			}
		})
	}
});

const BranchStore = create(Branch);

export default BranchStore